import InfoIconMarkdownCell from '@app/src/components/Table/Cells/InfoIconMarkdownCell'
import QuestionLinkCell from '@app/src/components/Table/Cells/QuestionLinkCell'
import ValueCell from '@app/src/components/Table/Cells/ValueCell'
import { useQuestionCategories } from '@app/src/hooks/useQuestionCategories'
import QuestionCategoryCell from '@app/src/pages/Configurations/SustainabilityLibraryPages/Questions/QuestionCategoryCell'
import type { QuestionCheckboxCellProps } from '@app/src/pages/Configurations/SustainabilityLibraryPages/Questions/QuestionCheckboxCell'
import QuestionCheckboxCell from '@app/src/pages/Configurations/SustainabilityLibraryPages/Questions/QuestionCheckboxCell'
import QuestionnairesCell from '@app/src/pages/Configurations/SustainabilityLibraryPages/Questions/QuestionnairesCell'
import type { Question } from '@app/src/types/resourceExplorer'
import { TableRow } from '@mui/material'
import React from 'react'

interface StandardQuestionRowProps {
  question: Question
  selectionProps?: Omit<QuestionCheckboxCellProps, 'question'>
}

const StandardQuestionRow: React.FC<StandardQuestionRowProps> = ({ question, selectionProps }) => {
  const { basicCategories } = useQuestionCategories()

  return (
    <TableRow>
      {selectionProps ? (
        <>
          <QuestionCheckboxCell question={question} {...selectionProps} />
          <ValueCell value={question.id} />
          <ValueCell value={question.questionText} maxRows={1} />
        </>
      ) : (
        <QuestionLinkCell question={question} />
      )}
      <InfoIconMarkdownCell value={question.guidance} />
      {basicCategories.map(category => (
        <QuestionCategoryCell
          key={category.name}
          categorizations={question.categorizations}
          categoryName={category.name}
        />
      ))}
      {selectionProps && <QuestionnairesCell question={question} />}
    </TableRow>
  )
}

export default StandardQuestionRow
